export default {
  checkbox: {
    appliesTo: 'all',
    dataType: 'BOOLEAN',
    defaultValue: false,
    defaultVisible: false,
    description: 'Boolean type',
    enabled: true,
    fieldType: 'CHECKBOX',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'checkbox',
    options: 'false,true',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 12,
    title: 'Checkbox',
  },
  date: {
    appliesTo: 'all',
    dataType: 'DATE',
    defaultVisible: false,
    description: 'Date type',
    enabled: true,
    fieldType: 'DATE',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'date',
    required: true,
    searchable: true,
    solrFieldTypeVal: 'date',
    sortOrder: 1,
    title: 'Date',
  },
  hidden: {
    hidden: true,
    title: 'Hidden (should not be displayed!)',
  },
  number: {
    appliesTo: 'all',
    dataType: 'NUMBER',
    defaultVisible: false,
    description: 'Number type',
    enabled: true,
    fieldType: 'TEXT',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'number',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'double',
    sortOrder: 22,
    title: 'Number',
  },
  password: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Password type',
    enabled: true,
    fieldType: 'PASSWORD',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'password',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 10,
    title: 'Password',
  },
  select: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultValue: 'Option 1',
    defaultVisible: false,
    description: 'Option type',
    enabled: true,
    fieldType: 'SELECT',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'select',
    options: 'Option 1, Option 2, Option 3,Option 4',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 2,
    title: 'Select',
  },
  text: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'String type',
    enabled: true,
    fieldType: 'TEXT',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'text',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 4,
    title: 'Text',
  },
  textarea: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Textarea type',
    enabled: true,
    fieldType: 'TEXTAREA',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'textarea',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'textarea',
    sortOrder: 5,
    title: 'Textarea',
  },
  title: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: true,
    description: 'The title of the asset',
    enabled: true,
    fieldType: 'TEXT',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: true,
    name: 'title',
    required: true,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 0,
    title: 'Title (localized & required)',
  },
  description: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'The description of the asset',
    enabled: true,
    fieldType: 'TEXTAREA',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: true,
    name: 'description',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'textarea',
    sortOrder: 1,
    title: 'Description',
  },
  selectMultiple: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Allows multiple options to be selected',
    enabled: true,
    fieldType: 'SELECT_MULTIPLE',
    filterable: false,
    hidden: false,
    isExcluded: false,
    isProtected: false,
    multilingual: true,
    name: 'selectMultiple',
    options: 'Action, Adventure, Sci-Fi, Funny , For The Little Ones, Fairytale, Mythical, Superhero, Girls, Animals, Fantasy, Sports, Princess, Watch with the Family, Feel good, Early learning, Educational value, Sing along, Science and nature, Friends , Animated, Automobile, Boys',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 17,
    title: 'Select Multiple',
  },
  selectMultipleDynamic: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Allows multiple options to be selected and add new ones on the fly',
    enabled: true,
    fieldType: 'SELECT_MULTIPLE_DYNAMIC',
    filterable: false,
    hidden: false,
    isExcluded: false,
    isProtected: false,
    multilingual: true,
    name: 'selectMultipleDynamic',
    options: 'one, two, three, thirty, thirty thousand, other, onscreen',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 17,
    title: 'Select Multiple Dynamic',
  },
  autocomplete: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Autocomplete field that triggers onAutocomplete',
    enabled: true,
    fieldType: 'AUTOCOMPLETE',
    filterable: false,
    hidden: false,
    isExcluded: false,
    isProtected: false,
    multilingual: true,
    name: 'autocomplete',
    options: '{"url":"/cms/api/companies", "queryParams": null, "filterKey": null}',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 17,
    title: 'Autocomplete',
  },
  protected: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultValue: 'Value cannot be changed',
    description: 'The title of the asset',
    enabled: true,
    fieldType: 'TEXT',
    filterable: false,
    hidden: false,
    isProtected: true,
    multilingual: true,
    name: 'protected',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 18,
    title: 'Protected text field',
  },
  publisher: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'The publisher of a channel',
    enabled: true,
    fieldType: 'AUTOCOMPLETE',
    filterable: true,
    hidden: false,
    isExcluded: false,
    isProtected: true,
    multilingual: false,
    name: 'publisher',
    options: '{"url":"/cms/api/editorial/search?type=autocomplete", "queryParams": [{"key":"term", "value":"value"}, {"key":"field", "value":"field"}]}',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 1,
    title: 'Publisher',
  },
};
